import styled from "styled-components";

export const PrimaryButton = styled.button`
  border: unset;
  padding: 15px 24px;
  background: ${({theme}) => theme.pink};
  box-shadow: 0 4px 12px rgba(55, 81, 255, 0.24);
  border-radius: 31px;
  outline: none;

  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.2px;
  color: ${({theme}) => theme.white};

  transition: all 300ms ease;

  :hover {
    cursor: pointer;
    background: ${({theme}) => theme.pinkLight};
  }

  :disabled {
    cursor: default !important;
    background: ${({theme}) => theme.pastelPink};
    box-shadow: unset;
  }

  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
  }
`
